export default __webpack_public_path__ + "static/media/img1.a94c3ab2.jpeg";